/*
 * Project:  mint-portfolio-template
 * File:      react-project.jsx
 * Author:   Amit Mishra (amit.mishra+CODA@gmail.com)
 * 
 * Description:
 * 
 * Revision History:
 *   2021-February-05: 
 * 
 * Copyright (c) 2021 Self
 * 
 * License:
 *    
 */

import React from "react";
import image from "../../assets/portfolio/project.png";

import "./react-project.scss";


const reactApp=(props)=>{
    return(
        <a href={props.headTo}>
        <div className=".wrapper react">
            <div>
           
            <h1 className="weight600"> 
            
               {props.headline}
            </h1>
            
            </div>
            
            <img src={props.img}></img>
          
        </div>
        </a>
    )
    

    
}

export default reactApp;